import creatDeclaration from './view/creatDeclaration.html'

export default {
    base: {
        state: 'declaration.addValTaxDeclaration.creatDeclaration',
        config: {
            url: '/creatDeclaration',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.addValTaxDeclaration.creatDeclaration.list',
            title: '申报表生成',
        },
    },
    list: {
        state: 'declaration.addValTaxDeclaration.creatDeclaration.list',
        config: {
            url: '/list',
            template: creatDeclaration,
            controller: 'creatDeclarationCtrl',

        },
    },
    detail: {
        state: 'declaration.addValTaxDeclaration.creatDeclaration.detail',
        config: {
            url: '/detail/:obj',
            template: require('./view/creatDeclarationDetail.html'),
            controller: 'creatDeclarationDetailCtrl',
            title: '申报表详情',
        },
    },
    edit: {
        state: 'declaration.addValTaxDeclaration.creatDeclaration.edit',
        config: {
            url: '/eidt/:obj',
            template: require('./view/creatDeclarationDetail.html'),
            controller: 'creatDeclarationDetailCtrl',
            title: '填写申报表',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/creatDeclaration/routers.js